import React from 'react'
import { LeafIcon, SparklesIcon, TruckIcon } from './icons/BenefitIcons'

const benefitsData = [
  {
    icon: <SparklesIcon />,
    title: "Impatto Scenografico",
    description: "Crea un'atmosfera magica e coinvolgente che stupirà i tuoi ospiti e renderà il tuo evento memorabile."
  },
  {
    icon: <LeafIcon />,
    title: "Soluzione Sostenibile",
    description: "Una scelta ecologica che riduce gli sprechi. Le nostre piante tornano in serra, pronte per il prossimo evento."
  },
  {
    icon: <TruckIcon />,
    title: "Servizio Completo",
    description: "Dalla progettazione alla consegna, dall'allestimento al ritiro. Pensiamo a tutto noi, tu goditi l'evento."
  }
]

const Benefits = () => {
  return (
    <section id="benefits" className="py-24 bg-white scroll-mt-24">
      <div className="container mx-auto px-6 text-center">
        <h2 className="text-4xl font-serif font-bold text-brand-green mb-4">Perché Noleggiare le Piante?</h2>
        <p className="text-lg text-brand-text/70 max-w-2xl mx-auto mb-20">
          Scopri i vantaggi di una soluzione flessibile, elegante e senza pensieri per il tuo allestimento.
        </p>
        <div className="grid md:grid-cols-3 gap-12">
          {benefitsData.map((benefit, index) => (
            <div key={index} className="flex flex-col items-center">
              <div className="bg-brand-green/10 text-brand-green rounded-full p-5 mb-6 inline-block">
                {benefit.icon}
              </div>
              <h3 className="text-2xl font-semibold text-brand-green mb-3">{benefit.title}</h3>
              <p className="text-brand-text/70 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Benefits